import {css, html, LitElement} from 'lit';
import {customElement} from 'lit/decorators';
import {containerStyles, normalizeStyles, typographyStyles,} from '@webs/components-library/theming';

@customElement('webs-footer-menu')
export class FooterMenu extends LitElement {
  static styles = [
    normalizeStyles,
    containerStyles,
    typographyStyles,
    css`
      :host {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -.4rem;
      }

      ::slotted(*) {
        flex: 0 0 50%;
        margin-bottom: 3rem;
        padding: 0 .4rem;
      }

      @media only screen and (min-width: 576px) {
        ::slotted(*) {
          flex: 0 0 33.3333%;
          padding: 0 .4rem;
        }
      }
    `,
  ];


  protected render(): unknown {
    return html`
      <slot name="first-column">
      </slot>
      <slot name="second-column">
      </slot>
      <slot name="third-column">
      </slot>
    `
  }
}
